import React from 'react';


function Universe() {
    return ( 
        <div className='container mt-5 p-5'>
            <div className='row'>
                <h1 style={{textAlign:"center", fontWeight:"500", fontSize:"28px", }} className='text-muted'>The Zerodha Universe</h1>
                <p style={{fontWeight:"400", fontSize:"20px", textAlign:"center", }}  className='text-muted'>Extend your trading and investment experience even further with our partner platforms</p>

                <div className='col-md-4 text-center mt-4'>
                    <img src='Media\images\streakLogo.png' alt='streak' style={{width:"150px", height:"150px"}}/>
                    <h3 style={{fontWeight:"500", fontSize:"22px", marginTop:"10px"}}>Streak</h3>
                    <p style={{fontWeight:"400", fontSize:"16px"}} className='text-muted'>Trade algorithmically without coding. Create, backtest and deploy your strategies in minutes.</p>
                </div>
                <div className='col-md-4 text-center mt-4'>
                    <img src='Media\images\sensibullLogo.svg' alt='sensibull' style={{width:"150px", height:"150px"}}/>
                    <h3 style={{fontWeight:"500", fontSize:"22px", marginTop:"10px"}}>Sensibull</h3>
                    <p style={{fontWeight:"400", fontSize:"16px"}} className='text-muted'>India's first options trading platform. Find the best options strategies for your market view.</p>
                </div>
                <div className='col-md-4 text-center mt-4'>
                    <img src='Media\images\dittoLogo.png' alt='finbox' style={{width:"150px", height:"150px"}}/>
                    <h3 style={{fontWeight:"500", fontSize:"22px", marginTop:"10px"}}>Finbox</h3>
                    <p style={{fontWeight:"400", fontSize:"16px"}} className='text-muted'>Research stocks with advanced screening tools, financial models, and data visualisations.</p>
                </div>

            </div>
            <div className='row mt-5 justify-content-center'>
                <button className='btn btn-primary '>Sign up for free</button>
            </div>
        </div>
    );
}

export default Universe;